export function formatNumberToCurrency(
  num: number = 0,
  minimumFractionDigits = 2,
): string {
  return num.toLocaleString("en-US", {
    minimumFractionDigits,
    maximumFractionDigits: 2,
  });
}

export function formatReadableAmounts(
  n: number | string,
  alwaysShowTwoDecimals: boolean = false,
): string {
  if (isNaN(Number(n))) {
    console.warn("Invalid number format");
    return "0";
  }
  const num = Number(n);
  let formatted: string;
  if (alwaysShowTwoDecimals) {
    formatted = num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    });
  } else {
    formatted = num.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 9,
      useGrouping: true,
    });
    // Remove trailing zeros after decimal point, but keep at least one digit if decimal exists
    if (formatted.includes(".")) {
      formatted = formatted.replace(/(\.\d*?[1-9])0+$/, "$1");
      formatted = formatted.replace(/\.0+$/, "");
    }
  }
  return formatted;
}
